<template>
  <div>
    <v-layout class="mb-4">
      <v-btn v-if="this.getRegisterInfo.type === 'list'"
      :color="ui.colorBlue" flat dark>
        <v-icon :color="ui.colorBlue"> reorder </v-icon>
      </v-btn>
      <v-btn v-if="this.getRegisterInfo.type === 'search'"
      :color="ui.colorBlue" flat dark>
        <v-icon :color="ui.colorBlue"> manage_search </v-icon>
      </v-btn>
      <v-btn v-if="this.getRegisterInfo.dis === 'Electrical'"
      :color="ui.colorBlue" flat dark>
        <v-icon :color="ui.colorBlue"> bolt </v-icon>
      </v-btn>
      <v-btn v-if="this.getRegisterInfo.dis === 'Mechanical'"
      :color="ui.colorBlue" flat dark>
        <v-icon :color="ui.colorBlue"> attractions </v-icon>
      </v-btn>
      <v-btn v-if="this.getRegisterInfo.dis === 'Process'"
      :color="ui.colorBlue" flat dark>
        <v-icon :color="ui.colorBlue"> water_drop </v-icon>
      </v-btn>
      <v-spacer/>
      <v-btn v-if="
      this.getRegisterInfo.title !== '' &&
      this.getRegisterInfo.title !== undefined &&
      this.getRegisterInfo.title !== null
      "
      :color="ui.colorBlue" flat dark>
        <v-icon :color="ui.colorBlue"> title </v-icon>
      </v-btn>
      <v-btn v-if="
      this.getRegisterInfo.aid !== '' &&
      this.getRegisterInfo.aid !== undefined &&
      this.getRegisterInfo.aid !== null
      "
      :color="ui.colorBlue" flat dark>
        <v-icon :color="ui.colorBlue"> emoji_transportation </v-icon>
      </v-btn>
      <v-btn v-if="
      this.getRegisterInfo.ept !== '' &&
      this.getRegisterInfo.ept !== undefined &&
      this.getRegisterInfo.ept !== null
      "
      :color="ui.colorBlue" flat dark>
        <v-icon :color="ui.colorBlue"> assignment </v-icon>
      </v-btn>

      <!-- <div v-if ="false">
        <div v-if="btnSpinLoadMore === false">
          <v-btn
          @click="loadNextCheck(defineLoadNextCheck)"
          :color="ui.colorBlue"
          :disabled="this.tag === 'E8'"
          flat dark>
            <v-icon left :color="ui.colorBlue"> cloud </v-icon>
              load more
          </v-btn>
        </div>
        <div v-else>
          <BtnSpin dark :btnSpec="btnInfo1"/>
        </div>
      </div> -->
      <!-- <div v-else>
        <div v-if="btnSpinLoadMore === false">
          <v-btn
          @click="loadNext()"
          :color="ui.colorBlue"
          flat dark>
            <v-icon left :color="ui.colorBlue"> cloud </v-icon>
              load more
          </v-btn>
        </div>
        <div v-else>
          <BtnSpin dark :btnSpec="btnInfo1"/>
        </div>
      </div> -->
    </v-layout>
</div>
</template>

<script>
import { mapGetters } from "vuex";
// import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";

export default {
  components: {
    // BtnSpin
  },
  mixins: [apptheme, getList, accessFunctions],
  data() {
    return {
      btnSpinLoadMore: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  },
  beforeMount() {
    if (this.tag === "B6.W") {
      let plandid = this.getRegisterInfo.did;
      this.$store.dispatch("changePlanDID", plandid);
    }
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getSearchResults",
      "getRegisterInfo",
      "getCurrentPage"
    ]),
    defineLoadNextCheck() {
      let info = null;
      if (this.getRegisterInfo !== null) {
        if (this.getRegisterInfo.tag === "F1") {
          info = "link.fdid";
        }
      }
      return info;
    }
  }
};
</script>
